import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";
import { applyForConnectOpportunityRoute } from "./connect/route";

export const applyWorkOppRoute: RouteConfig<'with-page'> = {
    name: 'Apply for Work Opportunities',
    path: '/work-opps/apply',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
    dynamicChildren: [
        applyForConnectOpportunityRoute
    ]
}
